import type { FormChatMessage } from '@kushya/shared';

import { ChatBubble } from './ChatBubble';

interface ChatMessagesProps {
  messages: FormChatMessage[];
  streamingText?: string;
}

/**
 * Container for the list of chat messages.
 * Renders all messages with timestamps and optionally shows streaming text.
 */
export function ChatMessages({ messages, streamingText }: ChatMessagesProps) {
  return (
    <div className="flex flex-col gap-5">
      {messages.map((message) => (
        <ChatBubble
          key={message.id ?? message.createdAt}
          role={message.role === 'user' ? 'user' : 'assistant'}
          content={message.content}
          timestamp={message.createdAt}
        />
      ))}

      {streamingText && (
        <ChatBubble role="assistant" content={streamingText} isStreaming />
      )}
    </div>
  );
}
